var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWavyCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.995,
    height: 18,
    viewBox: "0 0 17.995 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_90520",
    "data-name": "Group 90520",
    transform: "translate(5105 14784.323)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2869",
    "data-name": "Ellipse 2869",
    cx: 4.944,
    cy: 4.944,
    rx: 4.944,
    ry: 4.944,
    transform: "translate(-5101 -14780.268)",
    fill: "#f30c0c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "verify",
    d: "M19.6,9.862,18.377,8.441a1.994,1.994,0,0,1-.423-1.134V5.777a1.743,1.743,0,0,0-1.737-1.737h-1.53a2.018,2.018,0,0,1-1.134-.423L12.133,2.394a1.813,1.813,0,0,0-2.267,0L8.453,3.627a2.076,2.076,0,0,1-1.134.414H5.762A1.743,1.743,0,0,0,4.026,5.777V7.316a2.047,2.047,0,0,1-.414,1.125L2.4,9.871a1.812,1.812,0,0,0,0,2.249l1.215,1.431a2.047,2.047,0,0,1,.414,1.125v1.539a1.743,1.743,0,0,0,1.737,1.737H7.319a2.018,2.018,0,0,1,1.134.423L9.875,19.6a1.813,1.813,0,0,0,2.267,0l1.422-1.224a1.994,1.994,0,0,1,1.134-.423h1.53a1.743,1.743,0,0,0,1.737-1.737v-1.53a2.018,2.018,0,0,1,.423-1.134L19.61,12.13A1.825,1.825,0,0,0,19.6,9.862ZM14.742,9.3l-3.121,3.121L10.4,13.641a.673.673,0,0,1-.954,0L7.265,11.464a.674.674,0,0,1,.954-.954l1.7,1.7,3.869-3.869a.674.674,0,1,1,.954.954Z",
    transform: "translate(-5107.006 -14786.319)",
    fill: "#f30c0c"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2870",
    "data-name": "Ellipse 2870",
    cx: 4.944,
    cy: 4.944,
    rx: 4.944,
    ry: 4.944,
    transform: "translate(-5101 -14780.268)",
    fill: "#f30c0c"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2871",
    "data-name": "Ellipse 2871",
    cx: 4.944,
    cy: 4.944,
    rx: 4.944,
    ry: 4.944,
    transform: "translate(-5101 -14780.268)",
    fill: "#f30c0c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83256",
    "data-name": "Path 83256",
    d: "M18.881,17.932l1.841-1.808a.69.69,0,0,0,.066-.888.625.625,0,0,0-.986-.066L17.96,17.011,16.119,15.17a.625.625,0,0,0-.986.066.69.69,0,0,0,.066.888l1.841,1.808L15.2,19.74a.69.69,0,0,0-.066.888.625.625,0,0,0,.986.066l1.841-1.841L19.8,20.694a.625.625,0,0,0,.986-.066.69.69,0,0,0-.066-.888Z",
    transform: "translate(-5114.001 -14793.255)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWavyCancel);
export default __webpack_public_path__ + "static/media/wavy-cancel.44d3a8f5442dc14496429056ebb34282.svg";
export { ForwardRef as ReactComponent };